export default __webpack_public_path__ + "static/media/panelM4.0fd347c2.png";